<form>
  <!-- Modal Header -->
  <div class="modal-header">
    <h4 class="modal-title">Shared Loan List</h4>
    <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()"></button>
  </div>

  <div class="modal-body">
    @for (loan of sharedLoanList; track loan) {
      <app-loan-card [loan]="loan" [selectedCustomer]="viewCustomer" [selectedProfile]="selectedProfile" [needRestrictionCustomer]="true"> </app-loan-card>
    }
  </div>
</form>
